// src/trello/workspace/types.ts
var TrelloWorkspaceAriResourceOwner = "trello", TrelloWorkspaceAriResourceType = "workspace";

export {
  TrelloWorkspaceAriResourceOwner,
  TrelloWorkspaceAriResourceType
};
